import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchHomeInsightsSummary,
  fetchHomeInsightsHeatmap,
  fetchHomeInsightsLocations,
  fetchHomeInsightsMostPoi,
  fetchHomeInsightsElectorial,
  fetchHomeInsightsSuburbInfo,
  fetchHomeInsightsBrandAffinity,
  fetchHomeInsightsWorkLocations,
  downloadHomeInsights,
} from '../store/actions/homeInsights-actions';

import {
  setInsightsCriteriaType,
  clearInsightsCriteriaBoundaries,
  clearInsightsCriteriaPois,
} from '../store/actions/criteria-actions';

import { fetchPois } from '../store/actions/location-actions';
import { setLastInsightPage } from '../store/actions/route-actions';

import Header from './Header';
import InsightsNavBar from './InsightsNavBar';
import SVGIcon from '../components/SVGIcon';
import HeatmapNotAvailable from '../components/HeatmapNotAvailable';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import SelectionNotAvailable from '../components/SelectionNotAvailable';
import LoadingContainer from '../components/LoadingContainer';
import SuburbInfo from '../components/SuburbInfo';
import DownloadPdf from '../components/DownloadPdf';
import HomeInsightSidebar from './HomeInsightSidebar';
import Heatmap from '../components/Heatmap';
import BarGraph from '../components/BarGraph';
import DownloadCSVButton from '../components/DownloadCSVButton';

import {
  validateReportCriteria,
  insertTitle,
  insertSubTile,
  chooseDownloadableBtn,
  checkDefaultTab,
} from '../utilities/report-helpers';

import {
  formatNumber,
  isSelectedMultipleAdm,
  isDataAvailable,
  searchStringInObjectArray,
} from '../utilities/helpers';

const mapStateToProps = (
  { auth, home, client, homeInsights, reports, insightsCriteria, locations },
  ownProps
) => ({
  scopes: auth.tokenPayload ? auth.tokenPayload.scopes : [],
  ...home,
  client,
  ...homeInsights,
  ...insightsCriteria,
  report: reports.reportDictionary[ownProps.reportId],
  insightType: insightsCriteria.insightType,
  organisation: insightsCriteria.organisation,
  ...locations,
  ableToDownloadCSV: chooseDownloadableBtn(
    'home',
    auth.tokenPayload.scopes,
    insightsCriteria.insightType
  ),
  organisationsAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].organisationsAvailable,
  geographyAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].geographyAvailable,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchHomeInsightsHeatmap,
      fetchHomeInsightsSummary,
      fetchHomeInsightsLocations,
      fetchHomeInsightsMostPoi,
      fetchHomeInsightsElectorial,
      fetchHomeInsightsSuburbInfo,
      downloadHomeInsights,
      fetchHomeInsightsBrandAffinity,
      fetchPois,
      fetchHomeInsightsWorkLocations,
      setInsightsCriteriaType,
      clearInsightsCriteriaBoundaries,
      clearInsightsCriteriaPois,
      setLastInsightPage,
    },
    dispatch
  );

class HomeInsights extends React.Component {
  state = {
    sideBarOpen: true,
    isHighstBrandAffinityNoData: false,
    isSuburbInfoNoData: false,
    isWorkLocationsBySuburbNoData: false,
    isHomeLocationsBySuburbNoData: false,
    showCriteriaModal: false,
    showSelectionWarning: false,
    selectionWarningText: '',
    isShowingHeatmapCount: 0,
  };

  componentDidMount() {
    this.props.setLastInsightPage('/home-insights');
    this.props.clearInsightsCriteriaPois();

    // check which tab should be right and dispatch redux store
    let selectedTab = checkDefaultTab(
      this.props.reportsType,
      this.props.insightType,
      this.props.geographyAvailable,
      this.props.organisationsAvailable
    );
    this.props.setInsightsCriteriaType(selectedTab);
    // validate before getdata
    const validateResult = this.handelValidateReportCriteria(selectedTab);
    validateResult.showSelectionWarning === false && this.loadData('');

    this.checkDataIsEmpty();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.criteriaId !== this.props.criteriaId) {
      // validate before getdata
      let selectedTab = checkDefaultTab(
        this.props.reportsType,
        this.props.insightType,
        this.props.geographyAvailable,
        this.props.organisationsAvailable
      );
      this.handelValidateReportCriteria(selectedTab);
    }

    if (
      prevProps.suburbInfoData !== this.props.suburbInfoData ||
      prevProps.brandAffinityData !== this.props.brandAffinityData ||
      prevProps.workLocationsData !== this.props.workLocationsData ||
      prevProps.locationsData !== this.props.locationsData
    ) {
      this.checkDataIsEmpty();
    }
  };

  handelValidateReportCriteria = selectedTab => {
    const reportCriteriaValid = validateReportCriteria({
      insightType: selectedTab,
      report: this.props.report,
      subcategory: null,
      organisation: this.props.organisation,
    });

    this.setState(() => ({
      ...reportCriteriaValid,
    }));
    return reportCriteriaValid;
  };

  loadData = (selectTab, selectedBoundaryArray) => {
    // All condition need call these api
    this.props.fetchHomeInsightsSummary();
     this.props.fetchHomeInsightsLocations();

    (this.props.insightType === 'geography' && (this.props.adm4 === null || this.props.adm4.length > 1)) && this.props.fetchHomeInsightsElectorial();

    (this.props.insightType === 'geography' && this.props.adm4 !== null) && this.props.fetchHomeInsightsSuburbInfo();
    this.props.insightType === 'geography' && this.props.fetchHomeInsightsWorkLocations();

    !isSelectedMultipleAdm(selectedBoundaryArray) &&
      this.props.fetchHomeInsightsHeatmap();

    selectTab === 'organisation' && this.props.fetchPois();

    //this.props.fetchHomeInsightsMostPoi();
    //this.props.fetchHomeInsightsBrandAffinity();

  };

  toggleSideBar = () =>
    this.setState(prevState => ({ sideBarOpen: !prevState.sideBarOpen }));

  handleHeatmapCount = () =>
    this.setState({
      isShowingHeatmapCount: this.state.isShowingHeatmapCount + 1,
    });

  heatMapRender = boundaryArray => {
    /*
       The logic of rendering the heatmap : check if there are multiple choices in one boundary.
        if yes -> render the HeatmapNotAvailable component
        if no  -> render the Heatmap component
    */
    const multipleChoicesText = [
      this.props.boundariesDictionary.district.name,
      this.props.boundariesDictionary.city.name,
      this.props.boundariesDictionary.locality.name,
      'Points of Interest',
    ];
    let hasMultipleChoices = {
      has: false,
      text: '',
    };

    for (let i = 0; i < boundaryArray.length; i++) {
      if (boundaryArray[i] !== null) {
        if (boundaryArray[i].length > 1)
          hasMultipleChoices = {
            has: true,
            text: multipleChoicesText[i],
          };
      }
    }

    return hasMultipleChoices.has ? (
      <HeatmapNotAvailable selectedBoundary={hasMultipleChoices.text} />
    ) : (
      <LoadingContainer
        loading={!this.props.heatMapDataLoaded}
        className="FootfallInsights_reports_grid_top content-card"
      >
        <Heatmap
          mapData={this.props.heatMapData ? this.props.heatMapData : []}
          isGeographyTab={this.props.insightType === 'geography'}
          adm4={this.props.adm4}
          isDataAvailable={isDataAvailable(this.props.heatMapData)}
          showTotalCount={this.state.isShowingHeatmapCount > 4}
        />
      </LoadingContainer>
    );
  };

  summaryRender = identifiedPercentage => {
    if (identifiedPercentage === 0) {
      return '0';
    } else if (identifiedPercentage > 0.01) {
      return formatNumber(identifiedPercentage);
    } else {
      return '<0.01';
    }
  };

  checkDataIsEmpty = () => {
    const {
      brandAffinityData,
      workLocationsData,
      suburbInfoData,
      locationsData,
    } = this.props;

    function isAllValueZero(currentValue) {
      // if all data value is zero, show placeholder notification
      return currentValue.value === 0;
    }

    this.setState({
      isSuburbInfoNoData:
        suburbInfoData.electedParty === '' && suburbInfoData.suburbType === '',
      isHighstBrandAffinityNoData: brandAffinityData.every(isAllValueZero),
      isHomeLocationsBySuburbNoData:
        locationsData !== null && locationsData.length === 0,
      isWorkLocationsBySuburbNoData:
        workLocationsData !== null && workLocationsData.length === 0,
    });
  };

  thirdSectionRender = () => {
    if (this.props.adm0 === null) {
      /* Not showing Top work locations by and Electorial profile graph when the boundaries level is country*/
      return (
        <React.Fragment>
          <LoadingContainer
            loading={!this.props.workLocationsDataLoaded}
            className="FootfallInsights_reports_grid_bottom-left content-card"
          >
            {this.props.client.reports.filter(e => e.name === 'work').length >
            0 ? (
              // issue 382, If a client doesn't have permissions for the Work Insights Report, show not available.
              <BarGraph
                data={
                  this.props.workLocationsData
                    ? this.props.workLocationsData
                    : []
                }
                title={`Top work locations by ${this.props.boundariesDictionary.locality.name.toLowerCase()}`}
                barOnScreen={5}
                isDataAvailable={isDataAvailable(this.props.workLocationsData)}
              />
            ) : (
              <SelectionNotAvailable
                text="Graph Temporarily Unavailable"
                buttonText=""
              />
            )}
          </LoadingContainer>
          <LoadingContainer
            loading={!this.props.electorialDataLoaded}
            className="FootfallInsights_reports_grid_bottom-right content-card"
          >
            <BarGraph
              data={this.props.electorialData ? this.props.electorialData : []}
              title={`${
                this.props.client.country === 'AU' ? 'Federal ' : ''
              }Electorial profile`}
              barOnScreen={5}
              isDataAvailable={isDataAvailable(this.props.electorialData)}
            />
          </LoadingContainer>
        </React.Fragment>
      );
    }

    return;
  };

  render() {
    const {
      insightType,
      adm0,
      adm1,
      adm2,
      adm3,
      adm4,
      poiId,
      downloadHomeInsights,
      downloadingCSV,
      summaryLoaded,
      summaryData,
      locationsDataLoaded,
      locationsData,
      brandAffinityDataLoaded,
      reportId,
      workLocationsData,
      workLocationsDataLoaded,
      suburbInfoData,
      suburbInfoDataLoaded,
    } = this.props;

    const boundaryTypeArray = [
      'Country',
      this.props.boundariesDictionary.district.name,
      this.props.boundariesDictionary.city.name,
      this.props.boundariesDictionary.locality.name,
    ];
    const foundIndex = [adm0, adm2, adm3, adm4].findIndex(element => {
      return element !== null;
    });

    // Showing heatmap count only 5 secs and reset
    if (this.state.isShowingHeatmapCount > 4) {
      setTimeout(
        function() {
          this.setState({ isShowingHeatmapCount: 0 });
        }.bind(this),
        5000
      );
    }
    return (
      <div className="FootfallInsights" data-html2canvas-ignore="true">
        <Header />
        {this.state.sideBarOpen && (
          <HomeInsightSidebar
            loadData={this.loadData}
            toggleSideBar={this.toggleSideBar}
            reportId={this.props.reportId}
            reportsType="home"
          />
        )}
        <main
          className={`FootfallInsights_main${
            this.state.sideBarOpen ? '' : ' FootfallInsights_main_full-width'
          }`}
        >
          {!this.state.sideBarOpen && (
            <button
              className="FootfallInsights_main_open-side-bar-button"
              onClick={this.toggleSideBar}
            >
              <SVGIcon icon="back-arrow" />
            </button>
          )}
          <div>
            <div className="FootfallInsights_main_top">
              <div className="container">
                <div className="FootfallInsights_title-bar">
                  <div className="FootfallInsights_title-bar_left">
                    <h1>
                      {insertTitle(this.props, this.state.showSelectionWarning)}
                    </h1>
                    <h3>
                      {insertSubTile(
                        this.props,
                        this.state.showSelectionWarning
                      )}
                    </h3>
                  </div>
                  <div className="FootfallInsights_date-range-group">
                    {Array.isArray(this.props.ableToDownloadCSV) &&
                      this.props.ableToDownloadCSV.length > 0 &&
                      this.props.client.props.enableAudienceBuilder !==
                        true && (
                        <DownloadCSVButton
                          downloadAudience={downloadHomeInsights}
                          downloadingCSV={downloadingCSV}
                          label="Download audience .csv"
                          reportType="home"
                          insightType={insightType}
                          ableToDownloadCSV={this.props.ableToDownloadCSV}
                        />
                      )}
                  </div>
                </div>
                {!this.state.showSelectionWarning && (
                  <LoadingContainer loading={!summaryLoaded}>
                    <div className="FootfallInsights_main_top_cards">
                      <div
                        className="content-card"
                        onClick={this.handleHeatmapCount}
                      >
                        <span className="FootfallInsights_main_top_cards_info">
                          {summaryData.locationsCount &&
                            formatNumber(summaryData.locationsCount)}
                        </span>
                        {insightType === 'geography'
                          ? `home locations identified`
                          : adm1 || adm2 || adm3 || adm4 || poiId
                          ? `home ${this.props.boundariesDictionary.locality.name.toLowerCase()}s`
                          : `home ${this.props.boundariesDictionary.region.name.toLowerCase()}s`}
                      </div>
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {this.summaryRender(summaryData.identifiedPercentage)}
                          %
                        </span>
                        {insightType === 'geography' &&
                        !adm1 &&
                        !adm2 &&
                        !adm3 &&
                        !adm4 &&
                        !poiId
                          ? `of devices profiled`
                          : `of total home locations`}
                      </div>
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {this.props.client.id ===
                            '5dc26da29b7b531cafa425f9' &&
                          insightType === 'geography'
                            ? summaryData.locationsCount &&
                              formatNumber(summaryData.locationsCount * 3000)
                            : summaryData.locationsTotalCount &&
                              formatNumber(summaryData.locationsTotalCount)}
                        </span>
                        {insightType === 'geography'
                          ? `location record analysed`
                          : summaryData.locationsTotalCount > 1
                          ? `points of interest`
                          : `point of interest`}
                      </div>
                    </div>
                  </LoadingContainer>
                )}
              </div>
            </div>
            <div className="FootfallInsights_reports container">
              <InsightsNavBar selectedReport={reportId} />

              {this.state.showSelectionWarning ? (
                <SelectionNotAvailable
                  text={this.state.selectionWarningText}
                  buttonText={this.state.selectionWarningButtonText}
                  openCriteriaModal={this.openCriteriaModal}
                  wholePage={true}
                />
              ) : (
                <div className="FootfallInsights_reports_tab-panel">
                  <div className="FootfallInsights_reports_grid">
                    {this.heatMapRender([adm2, adm3, adm4, poiId])}

                    {(insightType === 'geography' && !adm4) ||
                    (insightType === 'geography' && adm4.length > 1) ||
                    insightType === 'organisation' ? (
                      <LoadingContainer
                        loading={!locationsDataLoaded}
                        className="FootfallInsights_reports_grid_middle content-card"
                      >
                        {!this.state.isHomeLocationsBySuburbNoData ? (
                          <BarGraph
                            data={locationsData ? locationsData : []}
                            title={
                              adm1 || adm2 || adm3 || adm4 || poiId
                                ? `Home locations by ${this.props.boundariesDictionary.locality.name.toLowerCase()}s`
                                : `Home locations by ${this.props.boundariesDictionary.district.name.toLowerCase()}s`
                            }
                            barOnScreen={10}
                            buttonOpen={true}
                            isDataAvailable={isDataAvailable(locationsData)}
                            downloadOpen={searchStringInObjectArray(
                              'locations',
                              this.props.ableToDownloadCSV,
                              'value'
                            )}
                            downloadAudience={downloadHomeInsights}
                            reportType="home"
                            insightType={insightType}
                            downloadingCSV={this.props.downloadingCSV}
                          />
                        ) : (
                          <SelectionNotAvailable
                            text={
                              boundaryTypeArray[foundIndex] !== undefined
                                ? `No home locations identified for the selected ${boundaryTypeArray[foundIndex]}`
                                : `No home locations identified for the selected boudary`
                            }
                            buttonText={
                              boundaryTypeArray[foundIndex] !== undefined
                                ? `Select another ${boundaryTypeArray[foundIndex]}`
                                : `Select another boudary`
                            }
                          />
                        )}
                      </LoadingContainer>
                    ) : (
                      ''
                    )}

                    {insightType === 'organisation' ? (
                      /*
                    <LoadingContainer
                      loading={!mostPoiDataLoaded}
                      className="FootfallInsights_reports_grid_bottom content-card"
                    >
                      <BarGraph
                        data={
                          mostPoiData ? mostPoiData : []
                        }
                        title="Most visited POI's based on selected home region"
                        barOnScreen={10}
                        buttonOpen={true}
                        downloadOpen={true}
                      />
                    </LoadingContainer>
                    */ <div></div>
                    ) : (
                      <React.Fragment>
                        {/* In geography tab and adm4 (suburbs) NOT be selected or multuple adm4 selected*/}
                        {adm4 === null || adm4.length > 1 ? (
                          this.thirdSectionRender()
                        ) : (
                          <React.Fragment>
                            {' '}
                            {/* In geography tab and adm4 (suburbs) be selected */}
                            <LoadingContainer
                              loading={!brandAffinityDataLoaded}
                              className="FootfallInsights_reports_grid_left content-card"
                            >
                              {/*\!this.state.isHighstBrandAffinityNoData
                                    ?
                                    <BarGraph
                                      data={brandAffinityData
                                        ? brandAffinityData
                                        : []
                                      }
                                      title="Highest brand affinity"
                                      barOnScreen={5}
                                    />
                                    :
                                    <SelectionNotAvailable
                                      text={
                                        boundaryTypeArray[foundIndex] !== undefined
                                          ? `No home locations identified for the selected ${boundaryTypeArray[foundIndex]}`
                                          : `No home locations identified for the selected boudary`
                                        }
                                      buttonText={
                                        boundaryTypeArray[foundIndex] !== undefined
                                        ? `Select another ${boundaryTypeArray[foundIndex]}`
                                        : `Select another boudary`
                                      }
                                    />
                                    */}
                              <SelectionNotAvailable
                                text="Graph Currently Unavailable"
                                buttonText=""
                              />
                            </LoadingContainer>
                            <LoadingContainer
                              loading={!suburbInfoDataLoaded}
                              className="FootfallInsights_reports_grid_right content-card"
                            >
                              {!this.state.isSuburbInfoNoData ? (
                                <SuburbInfo
                                  data={suburbInfoData ? suburbInfoData : {}}
                                  title={`${this.props.boundariesDictionary.locality.name.toLowerCase()} Info`}
                                  place={
                                    adm4 &&
                                    adm4[0].label.substring(
                                      0,
                                      adm4[0].label.indexOf(',')
                                    )
                                  }
                                />
                              ) : (
                                <SelectionNotAvailable
                                  text={
                                    boundaryTypeArray[foundIndex] !== undefined
                                      ? `No home locations identified for the selected ${boundaryTypeArray[foundIndex]}`
                                      : `No home locations identified for the selected boudary`
                                  }
                                  buttonText={
                                    boundaryTypeArray[foundIndex] !== undefined
                                      ? `Select another ${boundaryTypeArray[
                                          foundIndex
                                        ].toLowerCase()}`
                                      : `Select another boudary`
                                  }
                                />
                              )}
                            </LoadingContainer>
                            <LoadingContainer
                              loading={!workLocationsDataLoaded}
                              className="FootfallInsights_reports_grid_bottom content-card"
                            >
                              {!this.state.isWorkLocationsBySuburbNoData ? (
                                <BarGraph
                                  data={
                                    workLocationsData ? workLocationsData : []
                                  }
                                  title="Work locations by suburb"
                                  barOnScreen={10}
                                  buttonOpen={true}
                                  isDataAvailable={isDataAvailable(
                                    workLocationsData
                                  )}
                                />
                              ) : (
                                <SelectionNotAvailable
                                  text={
                                    boundaryTypeArray[foundIndex] !== undefined
                                      ? `No home locations identified for the selected ${boundaryTypeArray[foundIndex]}`
                                      : `No home locations identified for the selected boudary`
                                  }
                                  buttonText={
                                    boundaryTypeArray[foundIndex] !== undefined
                                      ? `Select another ${boundaryTypeArray[
                                          foundIndex
                                        ].toLowerCase()}`
                                      : `Select another boudary`
                                  }
                                />
                              )}
                            </LoadingContainer>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="FootfallInsights_DownlaodPdf">
            <DownloadPdf
              reportType="HomeInsight"
              isDisabled={
                !(
                  summaryLoaded &&
                  locationsDataLoaded &&
                  workLocationsDataLoaded &&
                  suburbInfoDataLoaded &&
                  brandAffinityDataLoaded &&
                  this.props.heatMapDataLoaded &&
                  !this.state.showSelectionWarning
                )
              }
            />
            <CopyrightAndVersion />
          </div>
        </main>
      </div>
    );
  }
}

HomeInsights.propTypes = {
  client: PropTypes.object.isRequired, // eslint-disable-line
  report: PropTypes.object.isRequired, // eslint-disable-line
  reportId: PropTypes.string.isRequired,
  summaryLoaded: PropTypes.bool.isRequired,
  summaryData: PropTypes.object.isRequired, // eslint-disable-line
  heatMapDataLoaded: PropTypes.bool.isRequired,
  heatMapData: PropTypes.object.isRequired, // eslint-disable-line
  insightType: PropTypes.string,
  organisation: PropTypes.object, // eslint-disable-line
  subcategory: PropTypes.object, // eslint-disable-line
  fetchHomeInsightsHeatmap: PropTypes.func.isRequired,
  fetchHomeInsightsMostPoi: PropTypes.func.isRequired,
  fetchHomeInsightsSummary: PropTypes.func.isRequired,
  fetchHomeInsightsLocations: PropTypes.func.isRequired,
  fetchHomeInsightsElectorial: PropTypes.func.isRequired,
  fetchHomeInsightsBrandAffinity: PropTypes.func.isRequired,
  downloadHomeInsights: PropTypes.func.isRequired,
  fetchHomeInsightsSuburbInfo: PropTypes.func.isRequired,
  downloadingCSV: PropTypes.bool.isRequired,
};

HomeInsights.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeInsights);
